<div class="informations-complementaires" *ngIf="(datas$ | async) as datas">
  <ng-container *ngIf="Object.keys(datas).length > 0">
    <div class="inf-comps-actions">
      <button mat-raised-button type="button" color="primary"
              matTooltip="Ouvrir toutes les informations complémentaires"
              (click)="entities.openAll()" data-cy="btn-documents-all">
        Ouvrir tout
      </button>
      <button mat-raised-button type="button" color="primary"
              matTooltip="Fermer toutes les informations complémentaires"
              (click)="entities.closeAll()" data-cy="btn-documents-bel">
        Fermer tout
      </button>
    </div>
    <mat-accordion  multi>
      <mat-expansion-panel *ngFor="let entityKey of Object.keys(datas)">
        <mat-expansion-panel-header >
          <mat-panel-title>{{entityKey}}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="pan-content">
          <app-information-complementaire-field
                  [edition_mode]="edition_mode"
                  *ngFor="let InstructionKey of Object.keys(datas[entityKey])"
                  [Bel]="Bel"
                  [Instruction]="datas[entityKey][InstructionKey]"
                  [label]="InstructionKey">
          </app-information-complementaire-field>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
</div>

